"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _redux = require("redux");

var _keyBy = _interopRequireDefault(require("lodash/keyBy"));

var _get = _interopRequireDefault(require("lodash/get"));

var _map = _interopRequireDefault(require("lodash/map"));

var _slice = _interopRequireDefault(require("lodash/slice"));

var _immutabilityHelper = _interopRequireDefault(require("immutability-helper"));

var _PageStatus = _interopRequireDefault(require("./PageStatus"));

var _normalizeParameters4 = _interopRequireDefault(require("./normalizeParameters"));

function getPageResults(action, resultKey) {
  var payload = action.payload;
  return (0, _get.default)(payload, resultKey, payload);
}

function getSlicedPageResults(action, resultKey) {
  var _normalizeParameters = (0, _normalizeParameters4.default)(action.meta.parameters),
      entriesPerPage = _normalizeParameters.entriesPerPage;

  var results = getPageResults(action, resultKey);
  return (0, _slice.default)(results, 0, entriesPerPage);
}

function pageRequest(state, action) {
  var parameters = (0, _normalizeParameters4.default)(action.meta.parameters);
  var pageNumber = parameters.pageNumber;
  return (0, _immutabilityHelper.default)(state, (0, _defineProperty2.default)({}, pageNumber, {
    $set: {
      parameters: parameters,
      error: (0, _get.default)(state, [pageNumber, 'error'], undefined),
      isFirstPage: (0, _get.default)(state, [pageNumber, 'isFirstPage'], undefined),
      isLastPage: (0, _get.default)(state, [pageNumber, 'isLastPage'], undefined),
      entities: (0, _get.default)(state, [pageNumber, 'entities'], []),
      status: _PageStatus.default.LOADING
    }
  }));
}

function pageSuccess(state, action, identifyBy, resultKey) {
  var _normalizeParameters2 = (0, _normalizeParameters4.default)(action.meta.parameters),
      pageNumber = _normalizeParameters2.pageNumber;

  var results = getPageResults(action, resultKey);
  var slicedResults = getSlicedPageResults(action, resultKey);
  return (0, _immutabilityHelper.default)(state, (0, _defineProperty2.default)({}, pageNumber, {
    $merge: {
      error: undefined,
      isFirstPage: pageNumber === 1,
      isLastPage: results.length <= slicedResults.length,
      entities: (0, _map.default)(slicedResults, identifyBy),
      status: _PageStatus.default.FULFILLED
    }
  }));
}

function pageFailure(state, action) {
  var payload = action.payload;

  var _normalizeParameters3 = (0, _normalizeParameters4.default)(action.meta.parameters),
      pageNumber = _normalizeParameters3.pageNumber;

  return (0, _immutabilityHelper.default)(state, (0, _defineProperty2.default)({}, pageNumber, {
    $merge: {
      error: payload,
      status: _PageStatus.default.REJECTED
    }
  }));
}

function createPaginationReducer(options) {
  var _options$types = (0, _slicedToArray2.default)(options.types, 3),
      RequestType = _options$types[0],
      SuccessType = _options$types[1],
      FailureType = _options$types[2],
      _options$identifyBy = options.identifyBy,
      identifyBy = _options$identifyBy === void 0 ? 'id' : _options$identifyBy,
      resultKey = options.resultKey; // eslint-disable-next-line default-param-last


  function pages() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments.length > 1 ? arguments[1] : undefined;

    switch (action.type) {
      case RequestType:
        return pageRequest(state, action);

      case SuccessType:
        return pageSuccess(state, action, identifyBy, resultKey);

      case FailureType:
        return pageFailure(state, action);

      default:
        return state;
    }
  } // eslint-disable-next-line default-param-last


  function currentPage() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
    var action = arguments.length > 1 ? arguments[1] : undefined;

    switch (action.type) {
      case SuccessType:
        return (0, _normalizeParameters4.default)(action.meta.parameters).pageNumber;

      default:
        return state;
    }
  } // eslint-disable-next-line default-param-last


  function entities() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments.length > 1 ? arguments[1] : undefined;

    switch (action.type) {
      case SuccessType:
        return (0, _immutabilityHelper.default)(state, {
          $merge: (0, _keyBy.default)(getSlicedPageResults(action, resultKey), identifyBy)
        });

      default:
        return state;
    }
  }

  function decorate(target) {
    // eslint-disable-next-line no-param-reassign
    target.plugin = function (reducer) {
      return function (state, action) {
        return reducer(target(state, action), action);
      };
    };

    return target;
  }

  return decorate((0, _redux.combineReducers)({
    entities: entities,
    pagination: (0, _redux.combineReducers)({
      currentPage: currentPage,
      pages: pages
    })
  }));
}

var _default = createPaginationReducer;
exports.default = _default;